import { isDeepChanged } from '../../utils/ChangeSpy';

/**
 * Check whether or not project data need to be updated.
 *
 * @param state {Immutable.Map} Project object.
 * @returns {boolean}
 */
function checkProject(state) {
  const fields = ['category', 'status', 'details', 'clientLead', 'harvcoLead', 'exec', 'active'];

  for (let i = 0, length = fields.length; i < length; i++) {
    if (state.getIn([fields[i], 'dirty'])) {
      return true;
    }
  }

  return false;
}

/**
 * Check whether or not industry, user, approval list data need to be updated.
 *
 * @param state {Immutable.Map} Object to be checked.
 * @returns {boolean}
 */
function checkGeneral(state) {
  for (let i = 0, length = state.size; i < length; i++) {
    if (state.getIn([i, 'dirty'])) {
      return true;
    }
  }

  return false;
}

/**
 * Check whether or not project page need to be updated.
 *
 * @param state {Immutable.Map} Project page object.
 * @returns {boolean}
 */
export default function detectDirty(state) {
  const { users, approvals, projectData, common, targets } = state;

  if (
    checkProject(projectData) ||
    checkGeneral(users) ||
    checkGeneral(approvals) ||
    isDeepChanged(common) ||
    isDeepChanged(targets)
  ) {
    return true;
  }

  if (state.templates) {
    let isDirty = false;

    try {
      isDirty = state.templates.some(template => template.get('mode') === 'edit');
      if (isDirty) return isDirty;
    } catch (error) {
      console.error(error);
    }
  }

  return false;
}
